/**
 * This is the default 'app' theme name.
 */
export var HarmonyDefaultThemeId = [
    'harmony',
    'harmonyLegacy',
    'Office',
];
export var HarmonyThemeType;
(function (HarmonyThemeType) {
    HarmonyThemeType["App"] = "App";
    HarmonyThemeType["Harmony"] = "Harmony";
    HarmonyThemeType["Shell"] = "Shell";
})(HarmonyThemeType || (HarmonyThemeType = {}));
//# sourceMappingURL=harmonyThemeData.js.map